'use client';

import * as Configurator from '@Stores/Configurator';
import * as PageProductStore from '@Stores/PageProduct';
import LayoutMain from '@Layouts/LayoutMain';
import Page404 from '@Pages/Page404';
import usePage from '@Queries/usePage';
import Page from '@Components/Page';
import PagePickPair from './pages/PagePick&Pair';
import PageProductConstructor from './pages/PageProductConstructor';
import PageProduct from './pages/PageProduct';

import type { FC, HTMLAttributes } from 'react';
import type { PageProductData } from './typings';

interface PageProductContainerProps {
  page?: PageProductData;
}

export interface PageProductProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const PageProductContainer: FC<PageProductContainerProps> = (props) => {
  const pageQuery = usePage<PageProductData>();
  const page = props.page || pageQuery.data;

  if (!page?.product) return <Page404 />;

  PageProductStore.init(page);
  const isPickPair = !!page.set;
  const isProductConstructor = !!page.configuratorOnPage;

  if (isProductConstructor) {
    const params = page.configuratorOnPage.parameterValues.filter((pv) => pv.selected);

    Configurator.updateStore(params);
  }

  return (
    <LayoutMain>
      <Page>
        {isPickPair && <PagePickPair />}
        {isProductConstructor && <PageProductConstructor />}
        {!isPickPair && !isProductConstructor && <PageProduct />}
      </Page>
    </LayoutMain>
  );
};

export default PageProductContainer;
